// Part grouping utility for the message rendering pipeline.

import type { AdjacentGroup } from "~/tools/group-adjacent";
import { groupAdjacent } from "~/tools/group-adjacent";

import type { BorgContentPart, BorgContentPartType } from "../models/borg-types";

export type PartGroup = AdjacentGroup<BorgContentPart, BorgContentPartType>;

const GROUPABLE_TYPES = new Set<BorgContentPartType>([
	"text",
	"progress",
	"tool_call",
	"suggestion",
	"source_link",
	"action",
]);

export const groupAdjacentParts = (parts: ReadonlyArray<BorgContentPart>): ReadonlyArray<PartGroup> =>
	groupAdjacent(
		parts,
		(part) => part.type,
		(type) => GROUPABLE_TYPES.has(type),
	);
